<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SubscriptionItem" });
import * as API from "../../services/api.js";
import { SUBSCRIPTION_STORE } from "../../services/store.js";
export let key;
export let onError = void 0;
const fetchSubscription = (key2) => {
    if (key2 === void 0) {
        return;
    }
    void API.fetchSubscription({ subscriptionKey: key2 }, onError);
};
$: fetchSubscription(key);
</script>

{#if key !== undefined && key in $SUBSCRIPTION_STORE }

    <slot subscription = { $SUBSCRIPTION_STORE[key] }>

        <pre>{ JSON.stringify($SUBSCRIPTION_STORE[key], null, 4) }</pre>

    </slot>

{/if}